/* 
Data handeling
*/

window.market = "";
window.currency = "";
window.currencySymbol = "";
window.marketVatRate = 0;
window.domain = "";
window.checkoutSession = "";
window.language = "";

window.priceSubtotal = 0;
window.priceTip = 0;
window.priceDiscount = 0;
window.priceShipping = 0;
window.pricePayment = 0;
window.priceTotal = 0;

window.vatSubtotal = 0;
window.vatTip = 0;
window.vatDiscount = 0;
window.vatShipping = 0;
window.vatPayment = 0;
window.vatTotal = 0;

window.discountCode = "";
window.discountStatus = "";
window.discountMinOrder = 0;
window.discountType = "";
window.discountValueType = "";

window.selectedCountry = "";
window.renderedShippingRates = [];

window.email = "";
window.phone = "";
window.billingCompany = "";
window.billingCId = "";
window.billingVAT = "";
window.billingFirstName = "";
window.billingLastName = "";
window.billingAddress = "";
window.billingZip = "";
window.billingCity = "";
window.billingCountry = "";
window.shippingFirstName = "";
window.shippingLastName = "";
window.shippingAddress = "";
window.shippingZip = "";
window.shippingCity = "";
window.shippingCountry = "";
window.differentShippingAddress = false;

window.acceptMarketing = false;
window.acceptTerms = false;
window.acceptPrivacy = false;

window.customerId = "";
window.isUser = false;

window.paymentMethod = "";
window.shippingMethod = "";
window.shippingType = "";

window.pointId = "";
window.pointName = "";

window.cartNote = "";
window.cart = {};

window.payId = "";

/*
Currency handeling
*/

// Function to map currency codes to symbols and store them in 'currencySymbol'
const setCurrencySymbol = () => {
  const currencyCode = getNCookie("n_currency") || "";

  switch (currencyCode) {
    case "CZK":
      currencySymbol = "Kč";
      break;
    case "EUR":
      currencySymbol = "€";
      break;
    case "USD":
      currencySymbol = "$";
      break;
    case "GBP":
      currencySymbol = "£";
      break;
    case "AUD":
      currencySymbol = "A$";
      break;
    case "CAD":
      currencySymbol = "C$";
      break;
    case "JPY":
      currencySymbol = "¥";
      break;
    case "INR":
      currencySymbol = "₹";
      break;
    case "CHF":
      currencySymbol = "Fr";
      break;
    default:
      currencySymbol = ""; // Default to an empty string if the currency isn't listed
  }
};

/* 
Checkout session handeling
*/

// Function to get a cookie by name
const getNCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

// Function to set a cookie
const setNCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

// Function to remove a specified cookie by name
function removeNCookie(cookieName) {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  console.log(`${cookieName} cookie removed`);
}

function setLoading () {
  const i = document.getElementById("checkoutLoading");
  i.classList.add("visible");
}

function removeLoading () {
  const i = document.getElementById("checkoutLoading");
  i.classList.remove("visible");
}

/*
Cookie handeling
*/

// Function to store values in the variables from cookies
const storeSessionValues = () => {
  market = getNCookie("n_market") || "";
  marketVatRate = parseFloat(getNCookie("n_marketVatRate")) || 21;
  currency = getNCookie("n_currency") || "";
  domain = getNCookie("n_domain") || "";
  language = getNCookie("n_language") || "en";
  const urlParams = new URLSearchParams(window.location.search);
  const sessionID = urlParams.get("nchk");
  checkoutSession = sessionID;
  window.cartNote = localStorage.getItem('cartNote');
  console.log('cartNote from localStorage:', window.cartNote);
};

/* 
Pricing handeling
*/

// Function to apply the currency symbol, divide price by 100, format it, and separate thousands with spaces
const applyMoneyFilter = () => {
  const currencySymbolPlace = getNCookie("n_currencySymbol-place") || "before"; // 'before' or 'after'

  // Find all elements with the class 'filter-money'
  document.querySelectorAll(".filter-money").forEach((element) => {
    let price = parseFloat(element.textContent.trim()); // Get the price and convert it to a number

    // Divide the price by 100
    price = price / 100;

    // Format the price and separate thousands by space
    let formattedPrice =
      price % 1 === 0
        ? price
            .toLocaleString("en-US", { minimumFractionDigits: 0 })
            .replace(/,/g, " ")
        : price
            .toLocaleString("en-US", { minimumFractionDigits: 2 })
            .replace(/,/g, " ");

    // Place the currency symbol either before or after the price based on the cookie
    if (currencySymbolPlace === "after") {
      element.textContent = `${formattedPrice} ${currencySymbol}`;
    } else {
      element.textContent = `${currencySymbol} ${formattedPrice}`;
    }
  });
};

// Function to update priceTotal
const updatePriceTotal = () => {
  priceTotal = priceSubtotal - priceDiscount + priceShipping + pricePayment + priceTip;
  vatTotal = vatSubtotal - vatDiscount + vatShipping + vatPayment + vatTip;

  document.querySelectorAll(".dataSubtotal").forEach((element) => {
    element.textContent = priceSubtotal;
  });

  document.querySelectorAll(".dataShipping").forEach((element) => {
    element.textContent = priceShipping;
  });

  document.querySelectorAll(".dataPayment").forEach((element) => {
    element.textContent = pricePayment;
  });

  document.querySelectorAll(".dataDiscount").forEach((element) => {
    element.textContent = priceDiscount;
  });

  document.querySelectorAll(".dataTotal").forEach((element) => {
    element.textContent = priceTotal;
  });

  // Apply currency symbol filter after updating prices
  applyMoneyFilter();
};

// Function to update pricing variables
const setPriceSubtotal = (newSubtotal) => {
  priceSubtotal = newSubtotal;
  vatSubtotal = (newSubtotal * marketVatRate) / 100;
  updatePriceTotal();
};

const setPriceDiscount = (newDiscount) => {
  priceDiscount = newDiscount;
  vatDiscount = (newDiscount * marketVatRate) / 100;
  updatePriceTotal();
};

const setPriceShipping = (newShipping) => {
  priceShipping = newShipping;
  vatShipping = (newShipping * marketVatRate) / 100;
  updatePriceTotal();
};

const setPricePayment = (newPayment) => {
  pricePayment = newPayment;
  vatPayment = (newPayment * marketVatRate) / 100;
  updatePriceTotal();
};

const setPriceTip = (newTip) => {
  priceTip = newTip;
  vatTip = (newTip * marketVatRate) / 100;
  updatePriceTotal();
};

/* 
Cart handeling
*/

// Function to fetch cart data from cart.js
const fetchCartData = async () => {
  try {
    const response = await fetch("/cart.js");
    cart = await response.json();

    setPriceSubtotal(cart.total_price);
    updateCheckoutData("priceSubtotal", cart.total_price / 100);

    updatePriceTotal();
  } catch (error) {
    console.log("Error fetching cart data:", error);
  }
};

/* 
Order Information Handeling
*/

// Function to perform API call to update checkout data
const updateCheckoutData = async (variableName, value) => {
  // Only proceed if the variable name is provided
  if (value === null || value === undefined || Number.isNaN(value)) {
    return;
  }

  // Get the current checkout session from the cookie
  const urlParams = new URLSearchParams(window.location.search);
  const sessionID = urlParams.get("nchk");

  if (!sessionID) {
    console.error("Checkout session not found.");
    return;
  }

  try {
    const response = await fetch(
      `/a/api/updatecheckout/${sessionID}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          [variableName]: value,
        }),
      }
    );

    if (!response.ok) {
      throw new Error(`Error updating checkout data: ${response.statusText}`);
    }
  } catch (error) {
    console.error("Failed to update checkout data:", error);
  }
};


// Function to set up listeners for all inputs and update the variables accordingly on 'blur' and handle autofill
const setupInputListeners = () => {
  // Helper function to update values
  const updateValue = (inputId, variableName) => {
    const inputElement = document.getElementById(inputId);

    if (inputElement) {
      const value = inputElement.value;

      // Dynamically update the corresponding global variable
      switch (variableName) {
        case "email":
          email = value;
          break;
        case "phone":
          phone = value;
          break;
        case "billingCompany":
          billingCompany = value;
          break;
        case "billingCId":
          billingCId = value;
          break;
        case "billingVAT":
          billingVAT = value;
          break;
        case "billingFirstName":
          billingFirstName = value;
          break;
        case "billingLastName":
          billingLastName = value;
          break;
        case "billingAddress":
          billingAddress = value;
          break;
        case "billingZip":
          billingZip = value;
          break;
        case "billingCity":
          billingCity = value;
          break;
        case "billingCountry":
          billingCountry = value;
          break;
        case "shippingFirstName":
          shippingFirstName = value;
          break;
        case "shippingLastName":
          shippingLastName = value;
          break;
        case "shippingAddress":
          shippingAddress = value;
          break;
        case "shippingZip":
          shippingZip = value;
          break;
        case "shippingCity":
          shippingCity = value;
          break;
        case "shippingCountry":
          shippingCountry = value;
          break;
        default:
          console.log(`Unknown variable name: ${variableName}`);
      }

      // Call API to update checkout data with the new value
      updateCheckoutData(variableName, value);
    }
  };

  const inputs = [
    { id: "cDataEmail", variable: "email" },
    { id: "cDataPhone", variable: "phone" },
    { id: "cDataBillingCompany", variable: "billingCompany" },
    { id: "cDataBillingCId", variable: "billingCId" },
    { id: "cDataBillingVAT", variable: "billingVAT" },
    { id: "cDataBillingFirstName", variable: "billingFirstName" },
    { id: "cDataBillingLastName", variable: "billingLastName" },
    { id: "cDataBillingAddress", variable: "billingAddress" },
    { id: "cDataBillingZip", variable: "billingZip" },
    { id: "cDataBillingCity", variable: "billingCity" },
    { id: "cDataBillingCountry", variable: "billingCountry" },
    { id: "cDataShippingFirstName", variable: "shippingFirstName" },
    { id: "cDataShippingLastName", variable: "shippingLastName" },
    { id: "cDataShippingAddress", variable: "shippingAddress" },
    { id: "cDataShippingZip", variable: "shippingZip" },
    { id: "cDataShippingCity", variable: "shippingCity" },
    { id: "cDataShippingCountry", variable: "shippingCountry" },
  ];

  inputs.forEach(({ id, variable }) => {
    const inputElement = document.getElementById(id);

    if (inputElement) {
      // Handle 'blur' and 'change' events (for manual input and autofill)
      inputElement.addEventListener("blur", () => updateValue(id, variable));

      // Delay for autofill detection
      setTimeout(() => updateValue(id, variable), 1000); // Delayed check for autofill
    }
  });
};

// Function to set the customers country
document.getElementById("cDataCountry").addEventListener("change", (event) => {
  selectedCountry = event.target.value;
  billingCountry = event.target.value;
  shippingCountry = event.target.value;
  updateShippingOptionsByCountry(selectedCountry);
  updateCheckoutData("selectedCountry", shippingCountry);
});

// Function to check on page load
const checkForCountry = () => {
  const i = document.getElementById("cDataCountry").value;
  selectedCountry = i;
  billingCountry = i;
  shippingCountry = i;
  updateShippingOptionsByCountry(i);
  setTimeout(() => {
    updateShippingOptionsByCountry(i);
  }, 1000);
};

function updateSummaryVisibility() {
  // Check for pricePayment and add .active to .summary_line-payment if needed
  if (typeof pricePayment !== "undefined" && pricePayment > 1) {
    document
      .querySelectorAll(".summary_line-payment")
      .forEach(function (element) {
        element.classList.add("active");
      });
  } else {
    document
      .querySelectorAll(".summary_line-payment")
      .forEach(function (element) {
        element.classList.remove("active");
      });
  }

  // Check for priceDiscount and add .active to .summary_line-discount if needed
  if (typeof priceDiscount !== "undefined" && priceDiscount > 1) {
    document
      .querySelectorAll(".summary_line-discount")
      .forEach(function (element) {
        element.classList.add("active");
      });
  } else {
    document
      .querySelectorAll(".summary_line-discount")
      .forEach(function (element) {
        element.classList.remove("active");
      });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const phoneInputs = document.querySelectorAll(".format-tel");

  phoneInputs.forEach(function (phoneInput) {
    const countryCode = phoneInput.getAttribute("data-country-code") + " ";
    let userTyping = false;

    // Add the country code when the input is focused
    phoneInput.addEventListener("focus", function () {
      if (!userTyping) {
        phoneInput.value = countryCode;
      }
    });

    // Prevent removing the country code and format the input dynamically
    phoneInput.addEventListener("input", function (event) {
      let value = phoneInput.value;

      // If the user removes the country code, restore it (unless the user deletes everything)
      if (value.length === 0) {
        userTyping = false;
        phoneInput.value = ""; // Clear the input completely
        return;
      }

      if (!value.startsWith(countryCode) && value.length > 0) {
        phoneInput.value = countryCode;
      }

      // Remove non-numeric characters (except the + in the country code) and keep only the digits
      const digitsOnly = value
        .replace(/\D/g, "")
        .substring(countryCode.replace(/\D/g, "").length); // Adjust for dynamic country code

      // Format the digits dynamically with spaces after every 3 digits
      let formatted = "";
      for (let i = 0; i < digitsOnly.length; i++) {
        formatted += digitsOnly[i];
        if ((i + 1) % 3 === 0 && i < digitsOnly.length - 1) {
          formatted += " ";
        }
      }

      // Update the input field with the formatted value
      phoneInput.value = countryCode + formatted;

      // Mark that the user is typing
      userTyping = true;
    });

    // Allow the user to delete the whole input including the country code
    phoneInput.addEventListener("keydown", function (event) {
      // If the user is deleting everything
      if (phoneInput.selectionStart === 0 && event.key === "Backspace") {
        phoneInput.value = ""; // Clear the input completely
        userTyping = false;
      }
    });
  });
});

/* Put input into uppercase */
document.addEventListener('DOMContentLoaded', function() {
  const inputs = document.querySelectorAll('.input-auto-uppercase');
  
  inputs.forEach(function(input) {
    input.addEventListener('input', function() {
      this.value = this.value.toUpperCase();
    });
  });
});

/*
Handeling checkboxed
*/

// Function to update global variables based on checkbox state
function updateGlobalVariables(checkboxId, variableName) {
  const checkbox = document.getElementById(checkboxId);

  // Update the global variable based on the checkbox checked state
  if (checkbox) {
    if (variableName === "acceptMarketing") {
      acceptMarketing = checkbox.checked;
      updateCheckoutData("acceptMarketing", checkbox.checked);
    } else if (variableName === "acceptTerms") {
      acceptTerms = checkbox.checked;
      updateCheckoutData("acceptTerms", checkbox.checked);
    } else if (variableName === "acceptPrivacy") {
      acceptPrivacy = checkbox.checked;
      updateCheckoutData("acceptPrivacy", checkbox.checked);
    } else if (variableName === "differentShippingAddress") {
      differentShippingAddress = checkbox.checked;
      updateCheckoutData("differentShippingAddress", checkbox.checked);
    }
  }
}

// Add event listeners to the checkboxes
document.addEventListener("DOMContentLoaded", function () {
  // Checkboxes and their corresponding variables
  const checkboxVariableMapping = {
    checkAcceptMarketing: "acceptMarketing",
    checkAcceptTerms: "acceptTerms",
    checkAcceptPrivacy: "acceptPrivacy",
    checkDifferentDelivery: "differentShippingAddress"
  };

  // Loop through each checkbox and add event listener
  for (let [checkboxId, variableName] of Object.entries(
    checkboxVariableMapping
  )) {
    const checkbox = document.getElementById(checkboxId);
    if (checkbox) {
      // On load, update the variables based on the initial checkbox state
      updateGlobalVariables(checkboxId, variableName);

      // Add event listener to update variables on change
      checkbox.addEventListener("change", function () {
        updateGlobalVariables(checkboxId, variableName);
      });
    }
  }
});

// Function to toggle visibility of the shipping address form block
function toggleShippingFormVisibility() {
  const shippingFormBlock = document.querySelector(
    ".n_checkout-system--form_block.shipping"
  );
  const checkbox = document.getElementById("checkDifferentDelivery");

  if (checkbox && shippingFormBlock) {
    if (checkbox.checked) {
      shippingFormBlock.classList.add("visible");
    } else {
      shippingFormBlock.classList.remove("visible");
    }
  }
}

// Add event listener for when the checkbox changes
document.addEventListener("DOMContentLoaded", function () {
  const differentDeliveryCheckbox = document.getElementById(
    "checkDifferentDelivery"
  );

  if (differentDeliveryCheckbox) {
    // Initial check on page load
    toggleShippingFormVisibility();

    // Add change event listener to toggle the visibility on checkbox change
    differentDeliveryCheckbox.addEventListener(
      "change",
      toggleShippingFormVisibility
    );
  }
});

// Function to check a checkbox by its ID and trigger change event
function makeCheckboxChecked(checkboxId) {
  const checkbox = document.getElementById(checkboxId);

  if (checkbox && !checkbox.checked) { // Only check if it's not already checked
    checkbox.checked = true;

    // Trigger change event to ensure all listeners respond
    const event = new Event('change');
    checkbox.dispatchEvent(event);
  }
}

// makeCheckboxChecked('checkAcceptMarketing'); // Checks the 'acceptMarketing' checkbox


/*
Handeling dicount codes
*/

const reactivateDiscountCode = async (discountCode) => {
  const discountCodeElement = document.getElementById("cDataDiscountCode");
  const discountBtnLoading = document.querySelectorAll(".n_discount--loading");
  const discountBtnReady = document.querySelectorAll(".n_discount--title");

  if (!discountCode) {
    console.log("No discount code provided");
    return;
  }

  // Prepare the body for the POST request
  const bodyData = {
    discount_code: discountCode,
  };

  try {
    const response = await fetch("/a/api/reactivatediscount", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bodyData),
    });

    const responseData = await response.json();
    console.log(responseData);

    window.discountCode = "";
    window.discountStatus = "";
    window.discountMinOrder = 0;
    window.discountType = "";
    window.discountValueType = "";

    setPriceDiscount(0);

    updateCheckoutData("priceDiscount", 0);
    updateCheckoutData("discountCode", "");
    updateCheckoutData("discountStatus", "");
    updateCheckoutData("discountValueType", "");
    
    
  } catch (error) {
    console.error("Error applying discount:", error);
  }
};

// Tros Discotequos product IDs — discounts don't apply if cart contains ONLY these
const TROS_DISCOTEQUOS_PRODUCT_IDS = [
  10863365423447, // Botasky Pink
  10863365849431, // Botasky Mint
  10863366177111, // Botasky Tros Discotequos
  10862936981847, // Mikina Yellow
  10862937145687, // Mikina Black
  10862937407831, // Triko Mint
  10862937669975, // Triko Dark Green
  10862937964887, // Triko Peach
  10862938358103, // Košile Denim
  10862938620247, // Košile White
  10862938751319, // Ledvinka Black
  10862938915159, // Ledvinka Sage
];

// Returns true if cart contains ONLY Tros Discotequos products (i.e. no other products)
const cartIsOnlyTrosDiscotequos = () => {
  if (!window.cart || !Array.isArray(window.cart.items) || window.cart.items.length === 0) {
    return false;
  }
  return window.cart.items.every((item) =>
    TROS_DISCOTEQUOS_PRODUCT_IDS.includes(Number(item.product_id))
  );
};

// Products on which NO discount may be applied. If any of these is in the cart,
// the discount code is blocked entirely (Bubble computes the discount server-side,
// so per-line exclusion isn't possible here — this is the all-or-nothing guard).
const NO_DISCOUNT_PRODUCT_IDS = [
  11014527615319, // PRIM Botas 77 LE (limitovaná edice)
];

// True if the cart contains at least one product flagged "no discount".
const cartHasNoDiscountProduct = () => {
  if (!window.cart || !Array.isArray(window.cart.items)) return false;
  return window.cart.items.some((item) =>
    NO_DISCOUNT_PRODUCT_IDS.includes(Number(item.product_id))
  );
};

// Shipping-only discount codes. These take nothing off the cart — they zero one
// carrier's rate — so they never reach /a/api/applydiscount (which knows only
// fixed/percentage codes and would answer "invalid"). Resolved here instead,
// same as the CZ 3000 Kč threshold and the Lidl employee code below.
// Keys must be UPPERCASE.
const SHIPPING_DISCOUNT_CODES = {};

// The shipping code currently in play, or null. Deliberately not persisted —
// a reload clears it, so it can't be stacked on top of a normal discount code.
const getShippingDiscount = () =>
  SHIPPING_DISCOUNT_CODES[(window.__shipping_code || "").toUpperCase()] || null;

// Zero the matching carrier on the already-rendered shipping list. Used when the
// code is entered after the options are on screen; renderShippingOptions covers
// the case where they are drawn afterwards.
const applyShippingDiscountToRendered = (shippingDiscount) => {
  const options = document.querySelectorAll(
    ".n_s-shipping-selector--option_container[data-shipping-id]"
  );
  // -1 = nothing rendered yet, so we can't judge whether the code fits.
  if (options.length === 0) return -1;

  let matched = 0;

  options.forEach((option) => {
    const rate = {
      id: option.getAttribute("data-shipping-id"),
      point_widget: option.getAttribute("data-pointwidget"),
    };
    if (!shippingDiscount.appliesTo(rate)) return;

    matched += 1;
    option.setAttribute("data-shipping-price", "0");

    const priceElement = option.querySelector(".n_s-shipping-selector--price");
    if (priceElement) priceElement.textContent = "ZDARMA";

    // If this carrier is the one already picked, the total has to follow.
    // setPriceShipping recalculates VAT and the total.
    if (shippingMethod === rate.id) {
      setPriceShipping(0);
    }
  });

  return matched;
};

// Apply a shipping-only code entered in the discount field.
const applyShippingDiscountCode = (code) => {
  const shippingDiscount = SHIPPING_DISCOUNT_CODES[code];
  const matched = applyShippingDiscountToRendered(shippingDiscount);

  // Options are on screen and none of them is PPL — the carrier isn't offered in
  // this market (PPL is CZ-only), so the code can't do anything.
  if (matched === 0) {
    showDiscountError("wrongCountry");
    updateDiscountResponseVisual("invalid");
    return;
  }

  window.__shipping_code = code;

  // Record the code on the checkout/order so the 0 Kč PPL rate is traceable.
  // Only discountCode is set — discountStatus stays empty and priceDiscount 0,
  // so nothing downstream tries to redeem it as a money-off code.
  discountCode = code;

  updateDiscountResponseVisual("valid");
  showDiscountSuccess(shippingDiscount.success);
  updateCheckoutData("discountCode", code);
};

// Function to send POST request to apply discount
const applyDiscountCode = async () => {
  const discountCodeElement = document.getElementById("cDataDiscountCode");
  const discountCode = discountCodeElement ? discountCodeElement.value : "";
  const discountBtnLoading = document.querySelectorAll(".n_discount--loading");
  const discountBtnReady = document.querySelectorAll(".n_discount--title");

  if (!discountCode) {
    console.log("No discount code provided");
    return;
  }

  // Shipping-only codes are resolved locally — they never hit the discount API,
  // and the cart-content guards below don't apply because nothing comes off the
  // goods.
  const shippingCode = discountCode.trim().toUpperCase();
  if (SHIPPING_DISCOUNT_CODES[shippingCode]) {
    applyShippingDiscountCode(shippingCode);
    return;
  }

  // Block discount entirely if the cart contains only Tros Discotequos products
  if (cartIsOnlyTrosDiscotequos()) {
    showDiscountError("trosDiscotequos");
    updateDiscountResponseVisual("invalid");
    reactivateDiscountCode(discountCode);
    return;
  }

  // Block discount entirely if the cart contains any "no discount" product
  // (e.g. the PRIM Botas 77 LE watch). Guarantees flagged products are never discounted.
  if (cartHasNoDiscountProduct()) {
    showDiscountError("noDiscountProduct");
    updateDiscountResponseVisual("invalid");
    reactivateDiscountCode(discountCode);
    return;
  }

  discountBtnReady.forEach((btn) => btn.classList.remove("visible"));
  discountBtnLoading.forEach((btn) => btn.classList.add("visible"));

  // Prepare the body for the POST request
  const bodyData = {
    discountcode: discountCode,
  };

  try {
    const response = await fetch("/a/api/applydiscount", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bodyData),
    });

    const responseData = await response.json();
    console.log(responseData);
    await handleDiscountResponse(responseData);
  } catch (error) {
    console.error("Error applying discount:", error);
  }
};

const updateDiscountResponseVisual = (state) => {
  const discountCodeElement = document.getElementById("cDataDiscountCode");
  const discountBtnLoading = document.querySelectorAll(".n_discount--loading");
  const discountBtnReady = document.querySelectorAll(".n_discount--title");
  const discountBtnOk = document.querySelectorAll(".n_discount--ok");
  const discountInput = document.querySelectorAll(".n_discount_input");
  const discountBtn = document.querySelectorAll(".n_discount_btn");

  if (state === "valid") {
    discountBtnReady.forEach((btn) => btn.classList.remove("visible"));
    discountBtnOk.forEach((btn) => btn.classList.add("visible"));
    discountBtnLoading.forEach((btn) => btn.classList.remove("visible"));
    discountBtn.forEach((btn) => (btn.style.pointerEvents = "none"));
    discountInput.forEach((input) => input.classList.add("disabled"));
    updateSummaryVisibility();
    hideAllDiscountErrors();
    updatePriceTotal();
  }

  if (state === "invalid") {
    discountBtnReady.forEach((btn) => btn.classList.add("visible"));
    discountBtnLoading.forEach((btn) => btn.classList.remove("visible"));
    discountStatus = "invalid";
  }
};

function isDnes20Code(code) {
  return ['VASKYONA20','BOTASDNES20','VASKYONA20SK','BOTASDNES20SK'].includes(String(code || '').trim().toUpperCase());
}
function isDnes20Item(item, product, variant) {
  const name = (product.title + ' ' + product.handle).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/-/g,' ');
  const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map(t => t.trim());
  return Number(product.id) !== 11257670631767 && Number(item.product_id) !== 11257670631767 && tags.includes('promo-dnes20') && !/prestige|\bcsr\b|steiner|kovarik|\bvang\b/.test(name) && variant &&
    Number(item.quantity) > 0 && Number(item.price) > 0 && !product.gift_card &&
    !(Number(variant.compare_at_price) > Number(variant.price)) &&
    !(Number(item.final_price ?? item.price) < Number(item.original_price ?? item.price));
}

// Function to handle the discount response
const handleDiscountResponse = async (responseData) => {
  const discount = responseData.response;
  const discountCodeElement = document.getElementById("cDataDiscountCode");
  const hasDiscountItems = document.getElementById("hasDiscountItem").value;

  // First rule: Check if the discount is valid
  if (!discount.valid) {
    showDiscountError("invalid");
    updateDiscountResponseVisual("invalid");
    return;
  }

  // Second rule: Check if currency_code matches
  if (discount.currency_code !== currency) {
    showDiscountError("wrongCountry");
    updateDiscountResponseVisual("invalid");
    reactivateDiscountCode(discountCodeElement.value);
    return;
  }

  if (hasDiscountItems === "true" && discount.exclude_discounts === true && !isDnes20Code(discountCodeElement.value)) {
    showDiscountError("hasDiscountedItem");
    updateDiscountResponseVisual("invalid");
    reactivateDiscountCode(discountCodeElement.value);
    return;
  } 

  // Third rule: Check if the minimum order value is met
  if (priceSubtotal < discount.min_order_value) {
    console.log(
      `Order value does not meet the minimum required: ${discount.min_order_value}`
    );
    discountMinOrder = discount.min_order_value / 100;
    showDiscountError("minOrderValue");
    updateDiscountResponseVisual("invalid");
    reactivateDiscountCode(discountCodeElement.value);
    return;
  }

  // Fourth rule: Check accepted items rule
  if (discount.accepted_items_rule) {
    let acceptedItems;

    // Handle accepted_items depending on whether there's a single item or multiple items
    if (discount.accepted_items && discount.accepted_items.includes(",")) {
      acceptedItems = discount.accepted_items.split(",");
    } else {
      acceptedItems = [discount.accepted_items]; // Convert single item into array
    }

    const cartProductIds = cart.items.map((item) => item.product_id.toString());

    const hasMatchingItem = acceptedItems.some((acceptedItem) =>
      cartProductIds.includes(acceptedItem)
    );
    if (!hasMatchingItem) {
      showDiscountError("acceptedItems");
      updateDiscountResponseVisual("invalid");
      reactivateDiscountCode(discountCodeElement.value);
      return;
    }
  }

  // Fifth rule: Check if discount value is greater than subtotal
  if (discount.type === "fixed" && discount.value > priceSubtotal) {
    showDiscountError("lowSubtotal");
    updateDiscountResponseVisual("invalid");
    reactivateDiscountCode(discountCodeElement.value);
    return;
  }

  // Tagged campaign items are checked per variant, including mixed carts.
  if (isDnes20Code(discountCodeElement.value)) {
    let amount = 0;
    try {
      const products = new Map();
      for (const item of cart.items) {
        if (!products.has(item.handle)) {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(item.handle) + '.js', {cache:'no-store'});
          if (!response.ok) throw new Error('Campaign product unavailable');
          products.set(item.handle, await response.json());
        }
        const product = products.get(item.handle);
        const variant = product.variants.find(v => Number(v.id) === Number(item.variant_id || item.id));
        if (!isDnes20Item(item, product, variant)) continue;
        const unit = Number(item.final_price ?? item.price);
        const offer = currency === 'EUR' ? Math.round(unit * .8) : Math.round(unit * .8 / 100) * 100;
        amount += (unit - offer) * Number(item.quantity);
      }
    } catch (error) {
      showDiscountError('invalid');
      updateDiscountResponseVisual('invalid');
      return;
    }
    if (!(amount > 0)) {
      showDiscountError('acceptedItems');
      updateDiscountResponseVisual('invalid');
      reactivateDiscountCode(discountCodeElement.value);
      return;
    }
    setPriceDiscount(Math.min(priceSubtotal, amount));
  } else
  // Apply discount based on type
  if (discount.type === "fixed") {
    setPriceDiscount(discount.value);
  } else if (discount.type === "percentage") {
    setPriceDiscount((priceSubtotal * (discount.value / 100)) / 100);
  }

  console.log(discount);
  updateDiscountResponseVisual("valid");

  discountCode = discountCodeElement.value;
  window.discountType = discount.discount_type;
  window.discountStatus = "applyed";

  
  updateCheckoutData("priceDiscount", priceDiscount / 100);
  updateCheckoutData("discountCode", discountCode);
};

function freeShippingApply() { return false; }

// Function to show discount error based on the type
function showDiscountError(errorType) {
  // Hide all error containers first
  document
    .querySelectorAll(".n_checkout-system--discounterror_container")
    .forEach((container) => {
      container.classList.remove("visible");
    });

  // Show the relevant error container
  const errorContainer = document.getElementById(`discountError-${errorType}`);
  if (errorContainer) {
    errorContainer.classList.add("visible");
    setTimeout(() => {
      errorContainer.classList.remove("visible");
    }, 15000);
  }
}

// Confirmation for codes whose effect the summary lines can't show — free
// shipping never appears on the "Sleva" line, so without this the customer sees
// only a green tick and no reason why.
function showDiscountSuccess(successType) {
  document
    .querySelectorAll(".n_checkout-system--discountsuccess_container")
    .forEach((container) => {
      container.classList.remove("visible");
    });

  const successContainer = document.getElementById(
    `discountSuccess-${successType}`
  );
  // Stays visible — unlike an error it describes a state, not an event.
  if (successContainer) successContainer.classList.add("visible");
}

// Function to hide all discount errors
function hideAllDiscountErrors() {
  document
    .querySelectorAll(".n_checkout-system--discounterror_container")
    .forEach((container) => {
      container.classList.remove("visible");
    });
}

const hanldeDiscountVisual = (resultStatus) => {};

/* 
Fetching and handling the SHIPPING options
*/

// FUNCTION
// This function goes for toggeling the shipping options
const toggleWidgetContainer = (widgetContainer, isOpen) => {
  if (isOpen) {
    // Measure the height of the content inside the container
    const contentHeight = widgetContainer.scrollHeight + "px";

    // Set the height to the content height for smooth expansion
    widgetContainer.style.height = contentHeight;

    // After the transition ends, reset the height to auto
    widgetContainer.addEventListener("transitionend", function resetHeight() {
      widgetContainer.style.height = "auto";
      widgetContainer.removeEventListener("transitionend", resetHeight);
    });
  } else {
    // Set the height to current height (pixel value) before collapsing
    widgetContainer.style.height = widgetContainer.scrollHeight + "px";

    // Force reflow to apply the height before collapsing
    widgetContainer.offsetHeight;

    // Set the height to 0 for collapsing
    widgetContainer.style.height = "0";
  }
};

// FUNCTION
// This function goes for rendering the shipping options from the server
// Function to fetch shipping rates from the API with a dynamic market parameter
const fetchShippingOptions = async (market) => {
  try {
    const response = await fetch("/a/api/requestshipping", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ market: market }), // Send dynamic market in the request body
    });

    if (response.ok) {
      const data = await response.json();
      if (data.request === "success" && data.shipping_rates) {
        renderShippingOptions(data.shipping_rates);
        renderedShippingRates = data.shipping_rates;
      } else {
        console.error("Error: Shipping rates not found in the response.");
      }
    } else {
      console.error("Error: Failed to fetch shipping options.");
    }
  } catch (error) {
    console.error("Error fetching shipping options:", error);
  }
};

// Function to initialize shipping selection logic and update payment options based on the selected shipping method
const initializeShippingOptionsEvents = () => {
  document
    .querySelectorAll(".n_s-shipping-selector--option_container")
    .forEach((option) => {
      option.addEventListener("click", (event) => {
        // Handle the selection of a shipping method as usual
        document
          .querySelectorAll(".n_s-shipping-selector-wrapper")
          .forEach((wrapper) => {
            const widgetContainer = wrapper.querySelector(
              ".n_s-shipping-selector--option_widget_container"
            );
            if (widgetContainer) {
              toggleWidgetContainer(widgetContainer, false); // Collapse any open widget
            }
            wrapper.classList.remove("selected");
            wrapper
              .querySelector(".n_s-shipping-selector--checkbox")
              .classList.remove("checked");
            pointName = "";
            pointId = "";
            window.__botasGlsPoint = null;
            document.querySelectorAll("[data-gls-selection]").forEach(el => { el.textContent = "Prosím vyberte výdejní místo"; });
            resetPaymentSelections();
            resetBranchPlaceholders();
            clearShippingError();
          });

        const wrapper = option.closest(".n_s-shipping-selector-wrapper");
        wrapper.classList.add("selected");
        option
          .querySelector(".n_s-shipping-selector--checkbox")
          .classList.add("checked");

        const widgetContainer = wrapper.querySelector(
          ".n_s-shipping-selector--option_widget_container"
        );
        if (widgetContainer) {
          toggleWidgetContainer(widgetContainer, true); // Expand the new widget if applicable
        }

        // Update global variables
        shippingMethod = option.getAttribute("data-shipping-id");
        shippingType = option.getAttribute("data-shipping-type");
        setPriceShipping(
          parseFloat(option.getAttribute("data-shipping-price"))
        );

        updatePaymentSelectionVisibility();

        // Update the total price
        updatePriceTotal();

        // Call function to update the payment options based on the selected shipping method
        updatePaymentOptions(shippingMethod);
      });
    });
};

// Function to render the shipping options dynamically
const renderShippingOptions = (shippingRates) => {
  const shippingGroupContainer = document.querySelector(
    ".n_s-shipping-selection--group"
  );

  // Check if free shipping should be applied (CZ market + order over 3000 CZK, or Lidl employee code)
  const hasLidlCode = !!(window.__lidl_code || sessionStorage.getItem('lidl_active_code'));
  const shouldApplyFreeShipping = false;

  // A shipping-only code (e.g. PPLZDARMA) frees one carrier, not the whole list.
  const shippingDiscount = getShippingDiscount();

  // Check if all items in the cart do not require shipping
  const requiresShipping = window.cart.items.some((item) => item.requires_shipping);

  if (!requiresShipping) {
    // Render the email-only shipping option
    const emailOptionHTML = `
      <div class="n_s-shipping-selector--container available" id="email">
        <div class="n_s-shipping-selector-wrapper">
          <div
            class="n_s-shipping-selector--option_container"
            id="fetchDataShippingOptions"
            data-shipping-id="email"
            data-shipping-price="0"
            data-shipping-type="digital"
            data-pointwidget=""
          >
            <div class="n_s-shipping-selector--radio">
              <div class="n_s-shipping-selector--checkbox"></div>
            </div>
            <div class="n_s-shipping-selector--content">
              <span class="n_s-shipping-selector--title">E-mail</span>
              <span class="n_s-shipping-selector--price">0 ${currencySymbol}</span>
            </div>
          </div>
          <div class="n_s-shipping-selector--option_widget_container"></div>
        </div>
      </div>
    `;

    shippingGroupContainer.insertAdjacentHTML("beforeend", emailOptionHTML);

    // Initialize event listeners for the email option
    initializeShippingOptionsEvents();

    return; // Exit the function since only email option should be rendered
  }

  // Sort by `position` ascending (1,2,3,...). Missing/invalid -> push to end.
  const sortedRates = [...shippingRates].sort((a, b) => {
    const pa = Number.isFinite(+a.position) ? +a.position : Number.POSITIVE_INFINITY;
    const pb = Number.isFinite(+b.position) ? +b.position : Number.POSITIVE_INFINITY;
    return pa - pb || String(a.name).localeCompare(String(b.name)); // stable fallback
  });

  sortedRates.forEach((rate) => {
    let displayPrice = rate.price;

    // Free either because the whole order qualifies, or because a shipping-only
    // code covers this one carrier.
    const rateIsFree =
      shouldApplyFreeShipping ||
      !!(shippingDiscount && shippingDiscount.appliesTo(rate));

    if (rateIsFree) {
      displayPrice = 0;
    }

    // Create the shipping option container dynamically
    const shippingOptionHTML = `
      <div class="n_s-shipping-selector--container" id="${rate.id}">
        <div class="n_s-shipping-selector-wrapper">
          <div
            class="n_s-shipping-selector--option_container"
            id="fetchDataShippingOptions"
            data-shipping-id="${rate.id}"
            data-shipping-price="${displayPrice}"
            data-shipping-type="${rate.type}"
            data-pointwidget="${rate.point_widget || ""}"
          >
            <div class="n_s-shipping-selector--radio">
              <div class="n_s-shipping-selector--checkbox"></div>
            </div>
            <div class="n_s-shipping-selector--content">
              <span class="n_s-shipping-selector--main">
                <span class="n_s-shipping-selector--title">${rate.name}${document.documentElement.lang === "en" ? " — after dispatch" : ""}</span>
                ${rate.description ? `<span class="n_s-shipping-selector--note">${rate.description}</span>` : ''}
              </span>
              <span class="n_s-shipping-selector--price">${
                rateIsFree
                  ? (document.documentElement.lang === 'en' ? 'FREE' : 'ZDARMA')
                  : `${(displayPrice / 100).toLocaleString()} ${currencySymbol}`
              }</span>
            </div>
          </div>
          <div class="n_s-shipping-selector--option_widget_container">
            ${renderWidget(
              rate.point_widget
            )} <!-- Inject the widget if it exists -->
          </div>
        </div>
      </div>
    `;

    // Append each shipping option to the container
    shippingGroupContainer.insertAdjacentHTML("beforeend", shippingOptionHTML);
  });

  // After rendering, initialize event listeners for the shipping options
  initializeShippingOptionsEvents();

  // Call function to update the payment options based on the selected shipping method
  updatePaymentOptions(shippingMethod);
};

// Function to render widgets based on point_widget type
const renderWidget = (widgetType) => {
  if (widgetType === "gls") {
    return `<div class="botas-gls-widget"><button type="button" onclick="window.botasGlsPick(this)" class="n_s-shipping-selector--option_widget_zasilkovna-btn">Vybrat výdejní místo nebo box GLS</button><p data-gls-selection>Prosím vyberte výdejní místo</p></div>`;
  }
  if (widgetType === "zasilkovna") {
    return `
      <div class="n_s-shipping-selector--option_widget_wrapper" id="zasilkovnaWidget">
        <button onclick="Packeta.Widget.pick()" class="n_s-shipping-selector--option_widget_zasilkovna-btn n_global-element_box-shadow">
          <span class="n_s-shipping-selector--option_widget_zasilkovna-btn_text">Vybrat pobočku</span>
          <img src="https://cdn.shopify.com/s/files/1/0849/4435/5594/files/zasilkovna-logo-white.svg?v=1729440955">
        </button>
        <div class="n_s-shipping-selector--option_widget_zasilkovna-point_selected" id="zasilkovnaSelection">
          <span class="n_s-shipping-selector--option_widget_zasilkovna-point_placeholder">Prosím vyberte výdejní místo</span>
          <span class="n_s-shipping-selector--option_widget_zasilkovna-point_name dataZasilkovnaBranchName" style="display: none">Z-BOX Krnsko</span>
          <svg id="zasilkovnaAlertIcon" style="display: block;" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
          </svg>
          <svg id="zasilkovnaOkIcon" style="display: none;" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
          </svg>
        </div>
      </div>
    `;
  } else if (widgetType === "balikovna") {
    return `
      <div class="n_s-shipping-selector--option_widget_wrapper" id="balikovnaWidget">
        <button class="n_s-shipping-selector--option_widget_balikovna-btn n_global-element_box-shadow" onclick="openBalikovnaBranchSelection()">
          <span class="n_s-shipping-selector--option_widget_balikovna-btn_text">Vybrat pobočku</span>
          <img src="https://cdn.shopify.com/s/files/1/0849/4435/5594/files/balikovna-logo.svg?v=1729700832">
        </button>
        <div class="n_s-shipping-selector--option_widget_balikovna-point_selected">
          <span class="n_s-shipping-selector--option_widget_balikovna-point_placeholder">Prosím vyberte výdejní místo</span>
          <span class="n_s-shipping-selector--option_widget_balikovna-point_name dataBalikovnaBranchName" style="display: none">Z-BOX Krnsko</span>
          <svg id="balikovnaAlertIcon" style="display: block" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
          </svg>
          <svg id="balikovnaOkIcon" style="display: none" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
          </svg>
        </div>
      </div>
    `;
  } else if (widgetType === "ppl-point-smart") {
    return `
      <div class="n_s-shipping-selector--option_widget_wrapper" id="pplPointSmartWidget">
        <button class="n_s-shipping-selector--option_widget_ppl-btn n_global-element_box-shadow" onclick="openPplBranchSelection(null)">
          <span class="n_s-shipping-selector--option_widget_ppl-btn_text">Vybrat pobočku</span>
        </button>
        <div class="n_s-shipping-selector--option_widget_ppl-point_selected" id="pplPointSmartSelection">
          <span class="n_s-shipping-selector--option_widget_ppl-point_placeholder">Prosím vyberte výdejní místo</span>
          <span class="n_s-shipping-selector--option_widget_ppl-point_name dataPplBranchName" style="display: none"></span>
          <svg id="pplPointSmartAlertIcon" style="display: block" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
          </svg>
          <svg id="pplPointSmartOkIcon" style="display: none" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
          </svg>
        </div>
      </div>
    `;
  } else if (widgetType === "ppl-smart-box") {
    return `
      <div class="n_s-shipping-selector--option_widget_wrapper" id="pplSmartBoxWidget">
        <button class="n_s-shipping-selector--option_widget_ppl-btn n_global-element_box-shadow" onclick="openPplBranchSelection('ParcelShop, AlzaBox')">
          <span class="n_s-shipping-selector--option_widget_ppl-btn_text">Vybrat box</span>
        </button>
        <div class="n_s-shipping-selector--option_widget_ppl-point_selected" id="pplSmartBoxSelection">
          <span class="n_s-shipping-selector--option_widget_ppl-point_placeholder">Prosím vyberte výdejní místo</span>
          <span class="n_s-shipping-selector--option_widget_ppl-point_name dataPplBranchName" style="display: none"></span>
          <svg id="pplSmartBoxAlertIcon" style="display: block" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
          </svg>
          <svg id="pplSmartBoxOkIcon" style="display: none" class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
          </svg>
        </div>
      </div>
    `;
  } else {
    return "";
  }
};

const updateShippingOptionsByCountry = (selectedCountryCode) => {
  console.log("Selected Country Code:", selectedCountryCode);
  console.log("Rendered Shipping Rates:", renderedShippingRates);

  // Check if all items in the cart do not require shipping
  const requiresShipping = window.cart.items.some((item) => item.requires_shipping);

  const shippingPlaceholder = document.querySelector(
    ".n_s-shipping-selection--placeholder"
  );

  if (!requiresShipping) {
    // If no items require shipping, hide the placeholder and exit the function
    console.log("No items require shipping. Displaying email shipping option only.");
    if (shippingPlaceholder) {
      shippingPlaceholder.classList.add("hidden");
    }
    return;
  }

  // Proceed with normal logic if at least one item requires shipping
  renderedShippingRates.forEach((rate) => {
    console.log("Processing Shipping Rate:", rate);
    const shippingOption = document.getElementById(rate.id);

    // Check if the country is in the shipping method's available countries
    const isCountryAvailable = rate.countries.some(
      (country) => country.country_code === selectedCountryCode
    );

    console.log("Is Country Available:", isCountryAvailable);
    console.log("Shipping Option Element:", shippingOption);

    if (isCountryAvailable && shippingOption) {
      // Add 'available' class if the shipping method is available for the selected country
      shippingOption.classList.add("available");
      console.log(`Added 'available' class to shipping option with ID: ${rate.id}`);
      if (shippingPlaceholder) {
        shippingPlaceholder.classList.add("hidden");
        console.log("Hid the shipping placeholder");
      }
    } else if (shippingOption) {
      // Remove 'available' class if the shipping method is not available
      shippingOption.classList.remove("available");
      console.log(`Removed 'available' class from shipping option with ID: ${rate.id}`);
    }
  });
};



// Function to update Zasilkovna branch selection
function updateZasilkovnaBranch(branchName) {
  const placeholderElement = document.querySelector(
    ".n_s-shipping-selector--option_widget_zasilkovna-point_placeholder"
  );
  const branchNameElement = document.querySelector(
    ".n_s-shipping-selector--option_widget_zasilkovna-point_name"
  );
  const branchElementBox = document.querySelector(
    ".n_s-shipping-selector--option_widget_zasilkovna-point_selected"
  );
  const branchElementAlertIcon = document.getElementById("zasilkovnaAlertIcon");
  const branchElementOkIcon = document.getElementById("zasilkovnaOkIcon");

  if (placeholderElement && branchNameElement) {
    placeholderElement.style.display = "none"; // Hide the placeholder
    branchNameElement.style.display = "block"; // Show the branch name
    branchNameElement.textContent = branchName; // Update the branch name text
    branchElementBox.classList.add("ok");
    branchElementAlertIcon.style.display = "none";
    branchElementOkIcon.style.display = "block";

    branchNameElement.classList.add("dataBranchName"); // Add a class for easier tracking
  }
}

// Function to update Balikovna branch selection
function updateBalikovnaBranch(branchName) {
  const placeholderElement = document.querySelector(
    ".n_s-shipping-selector--option_widget_balikovna-point_placeholder"
  );
  const branchNameElement = document.querySelector(
    ".n_s-shipping-selector--option_widget_balikovna-point_name"
  );
  const branchElementBox = document.querySelector(
    ".n_s-shipping-selector--option_widget_balikovna-point_selected"
  );
  const branchElementAlertIcon = document.getElementById("balikovnaAlertIcon");
  const branchElementOkIcon = document.getElementById("balikovnaOkIcon");

  if (placeholderElement && branchNameElement) {
    placeholderElement.style.display = "none"; // Hide the placeholder
    branchNameElement.style.display = "block"; // Show the branch name
    branchNameElement.textContent = branchName; // Update the branch name text
    branchElementBox.classList.add("ok");
    branchElementAlertIcon.style.display = "none";
    branchElementOkIcon.style.display = "block";

    branchNameElement.classList.add("dataBranchName"); // Add a class for easier tracking
  }
}

// Function to update PPL branch selection
function updatePplBranch(branchName) {
  const pplPointSmartPlaceholder = document.querySelector(
    "#pplPointSmartSelection .n_s-shipping-selector--option_widget_ppl-point_placeholder"
  );
  const pplPointSmartName = document.querySelector(
    "#pplPointSmartSelection .n_s-shipping-selector--option_widget_ppl-point_name"
  );
  const pplPointSmartBox = document.getElementById("pplPointSmartSelection");
  const pplPointSmartAlertIcon = document.getElementById("pplPointSmartAlertIcon");
  const pplPointSmartOkIcon = document.getElementById("pplPointSmartOkIcon");

  if (pplPointSmartPlaceholder && pplPointSmartName) {
    pplPointSmartPlaceholder.style.display = "none";
    pplPointSmartName.style.display = "block";
    pplPointSmartName.textContent = branchName;
    pplPointSmartBox.classList.add("ok");
    pplPointSmartAlertIcon.style.display = "none";
    pplPointSmartOkIcon.style.display = "block";
    pplPointSmartName.classList.add("dataBranchName");
  }

  const pplSmartBoxPlaceholder = document.querySelector(
    "#pplSmartBoxSelection .n_s-shipping-selector--option_widget_ppl-point_placeholder"
  );
  const pplSmartBoxName = document.querySelector(
    "#pplSmartBoxSelection .n_s-shipping-selector--option_widget_ppl-point_name"
  );
  const pplSmartBoxBox = document.getElementById("pplSmartBoxSelection");
  const pplSmartBoxAlertIcon = document.getElementById("pplSmartBoxAlertIcon");
  const pplSmartBoxOkIcon = document.getElementById("pplSmartBoxOkIcon");

  if (pplSmartBoxPlaceholder && pplSmartBoxName) {
    pplSmartBoxPlaceholder.style.display = "none";
    pplSmartBoxName.style.display = "block";
    pplSmartBoxName.textContent = branchName;
    pplSmartBoxBox.classList.add("ok");
    pplSmartBoxAlertIcon.style.display = "none";
    pplSmartBoxOkIcon.style.display = "block";
    pplSmartBoxName.classList.add("dataBranchName");
  }
}

// Function to reset both Zasilkovna and Balikovna placeholders
function resetBranchPlaceholders() {
  const zasilkovnaPlaceholderElement = document.querySelector(
    ".n_s-shipping-selector--option_widget_zasilkovna-point_placeholder"
  );
  const zasilkovnaBranchNameElement = document.querySelector(
    ".n_s-shipping-selector--option_widget_zasilkovna-point_name"
  );
  const zasilkovnaBranchElementBox = document.querySelector(
    ".n_s-shipping-selector--option_widget_zasilkovna-point_selected"
  );
  const zasilkovnaAlertIcon = document.getElementById("zasilkovnaAlertIcon");
  const zasilkovnaOkIcon = document.getElementById("zasilkovnaOkIcon");

  const balikovnaPlaceholderElement = document.querySelector(
    ".n_s-shipping-selector--option_widget_balikovna-point_placeholder"
  );
  const balikovnaBranchNameElement = document.querySelector(
    ".n_s-shipping-selector--option_widget_balikovna-point_name"
  );
  const balikovnaBranchElementBox = document.querySelector(
    ".n_s-shipping-selector--option_widget_balikovna-point_selected"
  );
  const balikovnaAlertIcon = document.getElementById("balikovnaAlertIcon");
  const balikovnaOkIcon = document.getElementById("balikovnaOkIcon");

  if (zasilkovnaPlaceholderElement && zasilkovnaBranchNameElement) {
    zasilkovnaPlaceholderElement.style.display = "block"; // Show the placeholder
    zasilkovnaBranchNameElement.style.display = "none"; // Hide the branch name
    zasilkovnaBranchNameElement.textContent = ""; // Clear the branch name text

    // Reset Zasilkovna box and icons
    zasilkovnaBranchElementBox.classList.remove("ok");
    zasilkovnaAlertIcon.style.display = "block";
    zasilkovnaOkIcon.style.display = "none";
  }

  if (balikovnaPlaceholderElement && balikovnaBranchNameElement) {
    balikovnaPlaceholderElement.style.display = "block"; // Show the placeholder
    balikovnaBranchNameElement.style.display = "none"; // Hide the branch name
    balikovnaBranchNameElement.textContent = ""; // Clear the branch name text

    // Reset Balikovna box and icons
    balikovnaBranchElementBox.classList.remove("ok");
    balikovnaAlertIcon.style.display = "block";
    balikovnaOkIcon.style.display = "none";
  }

  // Reset PPL Point Smart
  const pplPointSmartPlaceholder = document.querySelector(
    "#pplPointSmartSelection .n_s-shipping-selector--option_widget_ppl-point_placeholder"
  );
  const pplPointSmartName = document.querySelector(
    "#pplPointSmartSelection .n_s-shipping-selector--option_widget_ppl-point_name"
  );
  const pplPointSmartBox = document.getElementById("pplPointSmartSelection");
  const pplPointSmartAlertIcon = document.getElementById("pplPointSmartAlertIcon");
  const pplPointSmartOkIcon = document.getElementById("pplPointSmartOkIcon");

  if (pplPointSmartPlaceholder && pplPointSmartName) {
    pplPointSmartPlaceholder.style.display = "block";
    pplPointSmartName.style.display = "none";
    pplPointSmartName.textContent = "";
    pplPointSmartBox.classList.remove("ok");
    pplPointSmartAlertIcon.style.display = "block";
    pplPointSmartOkIcon.style.display = "none";
  }

  // Reset PPL Smart Box
  const pplSmartBoxPlaceholder = document.querySelector(
    "#pplSmartBoxSelection .n_s-shipping-selector--option_widget_ppl-point_placeholder"
  );
  const pplSmartBoxName = document.querySelector(
    "#pplSmartBoxSelection .n_s-shipping-selector--option_widget_ppl-point_name"
  );
  const pplSmartBoxBox = document.getElementById("pplSmartBoxSelection");
  const pplSmartBoxAlertIcon = document.getElementById("pplSmartBoxAlertIcon");
  const pplSmartBoxOkIcon = document.getElementById("pplSmartBoxOkIcon");

  if (pplSmartBoxPlaceholder && pplSmartBoxName) {
    pplSmartBoxPlaceholder.style.display = "block";
    pplSmartBoxName.style.display = "none";
    pplSmartBoxName.textContent = "";
    pplSmartBoxBox.classList.remove("ok");
    pplSmartBoxAlertIcon.style.display = "block";
    pplSmartBoxOkIcon.style.display = "none";
  }
}

/*
Handeling the PAYMENT options
*/

// Function to show the available payment methods based on the selected shipping method
const updatePaymentOptions = (selectedShippingMethodId) => {
  console.log("updatePaymentOptions");

  // Check if all items in the cart do not require shipping
  const requiresShipping = window.cart.items.every((item) => item.requires_shipping);

  if (!requiresShipping) {
    // Hide all payment options by removing the 'available' class
    document
      .querySelectorAll(".n_s-payment-selector--container")
      .forEach((paymentOption) => {
        paymentOption.classList.remove("available");
      });

    // Show only the payment option with ID 'gateway'
    const emailPaymentOption = document.getElementById("gateway");
    if (emailPaymentOption) {
      emailPaymentOption.classList.add("available");
    }

    return; // Exit the function since we handled the "email" case
  }
  
  // Find the selected shipping method in renderedShippingRates
  const selectedShippingRate = renderedShippingRates.find(
    (rate) => rate.id === selectedShippingMethodId
  );

  if (!selectedShippingRate) {
    return;
  }

  // Hide all payment options by removing the 'available' class
  document
    .querySelectorAll(".n_s-payment-selector--container")
    .forEach((paymentOption) => {
      paymentOption.classList.remove("available");
    });

  // Loop through the available payments of the selected shipping rate
  selectedShippingRate.available_payments.forEach((payment) => {
    if (payment.visible) {
      const paymentOption = document.getElementById(payment.id);
      if (paymentOption) {
        paymentOption.classList.add("available");
      }
    }
  });
};

// Function to reset payment selections
const resetPaymentSelections = () => {
  // Remove 'selected' class from all payment wrappers and reset checkboxes
  document
    .querySelectorAll(".n_s-payment-selector-wrapper")
    .forEach((wrapper) => {
      wrapper.classList.remove("selected");
      paymentMethod = "";
      setPricePayment(0);
      updatePriceTotal();
    });
};

// Function to show the available payment methods based on the selected shipping method
document
  .querySelectorAll(".n_s-payment-selector--option_container")
  .forEach((option) => {
    option.addEventListener("click", (event) => {
      resetPaymentSelections();

      // Add 'selected' class to the clicked payment option's wrapper
      const wrapper = option.closest(".n_s-payment-selector-wrapper");
      wrapper.classList.add("selected");
      option
        .querySelector(".n_s-payment-selector--checkbox")
        .classList.add("checked");

      // Update global variables based on the selected option's data attributes
      paymentMethod = option.getAttribute("data-payment-id");
      setPricePayment(parseFloat(option.getAttribute("data-payment-price")));

      updateSummaryVisibility();

      clearPaymentError();

      // Update the total price
      updatePriceTotal();
    });
  });

function updatePaymentSelectionVisibility() {
  console.log("updatePaymentSelectionVisibility");
  const paymentPlaceholder = document.querySelector(
    ".n_s-payment-selection--placeholder"
  );
  const paymentOptions = document.querySelector(
    ".n_s-payment-selection--group"
  );

  // Check if shipping method has been selected
  if (shippingMethod) {
    // Hide placeholder and show payment options
    if (paymentPlaceholder) {
      paymentPlaceholder.classList.add("hidden"); // Add hidden class to trigger the CSS transition
    }
  } else {
    // Show placeholder if no shipping method is selected
    if (paymentPlaceholder) {
      paymentPlaceholder.classList.remove("hidden"); // Remove hidden class to show the placeholder again
    }
  }
}

/*
Visual for mobiles
*/

document.addEventListener("DOMContentLoaded", function () {
  function moveSubmitSection() {
    const submitSection = document.getElementById("submitSection");
    const infoSection = document.getElementById("infoSection");
    const formSection = document.getElementById("formSection");

    if (window.innerWidth <= 1000) {
      if (submitSection && infoSection) {
        infoSection.parentNode.insertBefore(
          submitSection,
          infoSection.nextSibling
        );
      }
    } else {
      if (submitSection && formSection) {
        formSection.parentNode.insertBefore(
          submitSection,
          formSection.nextSibling
        );
      }
    }
  }

  // Initial check
  moveSubmitSection();

  // Listen for window resizing
  window.addEventListener("resize", function () {
    moveSubmitSection();
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const summaryDrawer = document.querySelector(
    ".n_checkout-system-mobile_summary--drawer-total"
  );
  const cartSummary = document.querySelector(
    ".n_checkout-system-mobile_summary--cart"
  );

  if (summaryDrawer && cartSummary) {
    summaryDrawer.addEventListener("click", function () {
      // Toggle the 'visible' class to expand or collapse the cart
      cartSummary.classList.toggle("visible");

      // Optional: toggle arrow icon direction
      const arrowIcon = summaryDrawer.querySelector("svg");
      if (cartSummary.classList.contains("visible")) {
        arrowIcon.style.transform = "rotate(180deg)"; // Arrow pointing up when open
      } else {
        arrowIcon.style.transform = "rotate(0deg)"; // Arrow pointing down when closed
      }
    });
  }
});

/*
Rendering the data from server
*/

// Function to retrieve checkout data and populate inputs
const retrieveAndPopulateCheckoutData = async () => {
  const urlParams = new URLSearchParams(window.location.search);
  const checkoutSession = urlParams.get("nchk");
  const nuiParam = urlParams.get("nui");
  const checkoutLoading = document.getElementById("checkoutLoading");

  if (!checkoutSession) {
    console.error("No checkout session found in URL parameters.");
    return;
  }

  try {
    // Send POST request to retrieve checkout data
    const response = await fetch(
      `/a/api/retrievecheckout/${checkoutSession}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Error retrieving checkout data: ${response.statusText}`);
    }

    const data = await response.json();
    const checkoutData = data.response;

    // If 'nui=true', clear the cart and re-add items from 'checkoutData.cartItems'
    if (nuiParam === "true") {
      // Step 1: Clear the cart
      await fetch("/cart/clear.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Step 2: Parse cartItems and format them for POST request
      const items = checkoutData.cartItems.split(",").map((item) => {
        const [variantId, quantity] = item.match(/\d+/g);
        return { id: parseInt(variantId, 10), quantity: parseInt(quantity, 10) };
      });

      // Step 3: Add items back to the cart
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      });

      // Step 4: Reset to the current cookie
      removeNCookie("n_checkoutSession");
      setNCookie("n_checkoutSession", checkoutSession, 30)
      

      // Step 5: Remove 'nui=true' parameter and refresh the page
      urlParams.delete("nui");
      window.history.replaceState({}, "", `${window.location.pathname}?${urlParams}`);
      window.location.reload();
      return; // Stop further execution to avoid extra population while refreshing
    }

    // Define the inputs to be populated based on the response data
    const inputs = [
      { id: "cDataEmail", variable: "email" },
      { id: "cDataPhone", variable: "phone" },
      { id: "cDataBillingCompany", variable: "billingCompany" },
      { id: "cDataBillingCId", variable: "billingCId" },
      { id: "cDataBillingVAT", variable: "billingVAT" },
      { id: "cDataBillingFirstName", variable: "billingFirstName" },
      { id: "cDataBillingLastName", variable: "billingLastName" },
      { id: "cDataBillingAddress", variable: "billingAddress" },
      { id: "cDataBillingZip", variable: "billingZip" },
      { id: "cDataBillingCity", variable: "billingCity" },
      { id: "cDataShippingFirstName", variable: "shippingFirstName" },
      { id: "cDataShippingLastName", variable: "shippingLastName" },
      { id: "cDataShippingAddress", variable: "shippingAddress" },
      { id: "cDataShippingZip", variable: "shippingZip" },
      { id: "cDataShippingCity", variable: "shippingCity" },
    ];

    // Populate each input field with the corresponding checkout data
    inputs.forEach(({ id, variable }) => {
      const inputElement = document.getElementById(id);
      if (inputElement && checkoutData[variable] !== undefined) {
        inputElement.value = checkoutData[variable];
      }
    });

    // Check if differentShippingAddress is true and check the checkbox if so
    if (checkoutData.differentShippingAddress === true) {
      makeCheckboxChecked("checkDifferentDelivery");
      toggleShippingFormVisibility();
    }

    // Check if discount status is valid and populate discount code
    if (checkoutData.discountStatus === "valid" && checkoutData.discountCode) {
      const discountCodeElement = document.getElementById("cDataDiscountCode");
      if (discountCodeElement) {
        discountCodeElement.value = checkoutData.discountCode;
        setPriceDiscount(checkoutData.priceDiscount * 100);
        discountCode = checkoutData.discountCode;
        discountStatus = "valid";

        updateDiscountResponseVisual("valid");
      }
    }

    console.log("Checkout data populated successfully.");
  } catch (error) {
    console.error("Failed to retrieve and populate checkout data:", error);
  }
};

function initializeTipEvents() {
  const tipElements = document.querySelectorAll('.n_checkout-system--tip');

  tipElements.forEach(function(tip) {
    tip.addEventListener('click', function() {
      tipElements.forEach(function(el) {
        el.classList.remove('active');
      });

      this.classList.add('active');

      const tipValue = Number(this.getAttribute('data-tip-value'));

      setPriceTip(tipValue);
      console.log("Tip:", tipValue);
    });
  });
}



/* 
Applying the functions
*/

document.addEventListener("DOMContentLoaded", (event) => {
  retrieveAndPopulateCheckoutData();
  fetchCartData();
  applyMoneyFilter();
  setCurrencySymbol();
  storeSessionValues();
  setupInputListeners();
  fetchShippingOptions(market);
  updateSummaryVisibility();
  setTimeout(() => {
    checkForCountry();
    initializeTipEvents();
    removeLoading();
  }, 1000);
});